module.exports = {
  storage: require('./storage')
};



//////////////////
// WEBPACK FOOTER
// ./~/formiojs/src/providers/index.js
// module id = 628
// module chunks = 0